import * as React from 'react';
import { Route, Switch } from 'react-router';

import NotFoundLayout from './layouts/NotFoundLayout';
import SearchLayout from './layouts/SearchLayout';

export const Routes = (updateShowMessage:any) => (
  <Switch>
    <Route path="/"
           exact
           render={ props => (
             <SearchLayout { ...props } {...updateShowMessage} />
           )}
    />
    <Route component={NotFoundLayout} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/Routes.tsx